import {
  //
  ADD_ENQUIRY,
  ADD_ENQUIRY_FAILURE,
  ADD_ENQUIRY_SUCCESS,
  //
  DELETE_ENQUIRY,
  DELETE_ENQUIRY_FAILURE,
  DELETE_ENQUIRY_SUCCESS,
  //
  EDIT_ENQUIRY,
  EDIT_ENQUIRY_FAILURE,
  EDIT_ENQUIRY_SUCCESS,
  //
  FETCH_ENQUIRIES,
  FETCH_ENQUIRIES_FAILURE,
  FETCH_ENQUIRIES_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  DELETE_ENQUIRY_NOTE,
  DELETE_ENQUIRY_NOTE_FAILURE,
  DELETE_ENQUIRY_NOTE_SUCCESS,
  //
  DELETE_ENQUIRY_REMINDER_NOTE,
  DELETE_ENQUIRY_REMINDER_NOTE_FAILURE,
  DELETE_ENQUIRY_REMINDER_NOTE_SUCCESS,
  //
  OPEN_NOTE_ADD_MODAL,
  CLOSE_NOTE_ADD_MODAL,
  //
  OPEN_REMINDER_ADD_MODAL,
  CLOSE_REMINDER_ADD_MODAL,
  //
  ADD_ENQUIRY_NOTE,
  ADD_ENQUIRY_NOTE_SUCCESS,
  ADD_ENQUIRY_NOTE_FAILURE,
  //
  FETCH_ENQUIRIES_NOTES,
  FETCH_ENQUIRIES_NOTES_FAILURE,
  FETCH_ENQUIRIES_NOTES_SUCCESS,
  //
  ADD_ENQUIRY_REMINDER,
  ADD_ENQUIRY_REMINDER_SUCCESS,
  ADD_ENQUIRY_REMINDER_FAILURE,
  //
  FETCH_ENQUIRIES_REMINDERS,
  FETCH_ENQUIRIES_REMINDERS_FAILURE,
  FETCH_ENQUIRIES_REMINDERS_SUCCESS,
  //
  EXPORT_ENQUIRY,
  EXPORT_ENQUIRY_FAILURE,
  EXPORT_ENQUIRY_SUCCESS,
  //
  IMPORT_ENQUIRY,
  IMPORT_ENQUIRY_FAILURE,
  IMPORT_ENQUIRY_SUCCESS,
} from "./constants";

// List
export const fetchEnquiries = (payload) => ({
  type: FETCH_ENQUIRIES,
  payload,
});
export const fetchEnquiriesSuccess = (payload) => ({
  type: FETCH_ENQUIRIES_SUCCESS,
  payload,
});
export const fetchEnquiriesFailure = (payload) => ({
  type: FETCH_ENQUIRIES_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addEnquiry = (payload) => ({
  type: ADD_ENQUIRY,
  payload,
});
export const addEnquirySuccess = (payload) => ({
  type: ADD_ENQUIRY_SUCCESS,
  payload,
});
export const addEnquiryFailure = (payload) => ({
  type: ADD_ENQUIRY_FAILURE,
  payload,
});
// EDIT
export const editEnquiry = (payload) => ({
  type: EDIT_ENQUIRY,
  payload,
});
export const editEnquirySuccess = (payload) => ({
  type: EDIT_ENQUIRY_SUCCESS,
  payload,
});
export const editEnquiryFailure = (payload) => ({
  type: EDIT_ENQUIRY_FAILURE,
  payload,
});
// DELETE
export const deleteEnquiry = (payload) => ({
  type: DELETE_ENQUIRY,
  payload,
});
export const deleteEnquirySuccess = (payload) => ({
  type: DELETE_ENQUIRY_SUCCESS,
  payload,
});
export const deleteEnquiryFailure = (payload) => ({
  type: DELETE_ENQUIRY_FAILURE,
  payload,
});
// DELETE Enquiry Note
export const deleteEnquiryNote = (payload) => ({
  type: DELETE_ENQUIRY_NOTE,
  payload,
});
export const deleteEnquiryNoteSuccess = (payload) => ({
  type: DELETE_ENQUIRY_NOTE_SUCCESS,
  payload,
});
export const deleteEnquiryNoteFailure = (payload) => ({
  type: DELETE_ENQUIRY_NOTE_FAILURE,
  payload,
});
// DELETE Enquiry Reminder
export const deleteEnquiryReminderNote = (payload) => ({
  type: DELETE_ENQUIRY_REMINDER_NOTE,
  payload,
});
export const deleteEnquiryReminderNoteSuccess = (payload) => ({
  type: DELETE_ENQUIRY_REMINDER_NOTE_SUCCESS,
  payload,
});
export const deleteEnquiryReminderNoteFailure = (payload) => ({
  type: DELETE_ENQUIRY_REMINDER_NOTE_FAILURE,
  payload,
});
//
export const openNoteAddModal = (payload) => ({
  type: OPEN_NOTE_ADD_MODAL,
  payload,
});
export const closeNoteAddModal = (payload) => ({
  type: CLOSE_NOTE_ADD_MODAL,
  payload,
});
//
export const openReminderAddModal = (payload) => ({
  type: OPEN_REMINDER_ADD_MODAL,
  payload,
});
export const closeReminderAddModal = (payload) => ({
  type: CLOSE_REMINDER_ADD_MODAL,
  payload,
});
// ADD ENQUIRY NOTE
export const addEnquiryNote = (payload) => ({
  type: ADD_ENQUIRY_NOTE,
  payload,
});
export const addEnquiryNoteSuccess = (payload) => ({
  type: ADD_ENQUIRY_NOTE_SUCCESS,
  payload,
});
export const addEnquiryNoteFailure = (payload) => ({
  type: ADD_ENQUIRY_NOTE_FAILURE,
  payload,
});
// List Note
export const fetchEnquiriesNotes = (payload) => ({
  type: FETCH_ENQUIRIES_NOTES,
  payload,
});
export const fetchEnquiriesNotesSuccess = (payload) => ({
  type: FETCH_ENQUIRIES_NOTES_SUCCESS,
  payload,
});
export const fetchEnquiriesNotesFailure = (payload) => ({
  type: FETCH_ENQUIRIES_NOTES_FAILURE,
  payload,
});
// ADD ENQUIRY REMINDER
export const addEnquiryReminder = (payload) => ({
  type: ADD_ENQUIRY_REMINDER,
  payload,
});
export const addEnquiryReminderSuccess = (payload) => ({
  type: ADD_ENQUIRY_REMINDER_SUCCESS,
  payload,
});
export const addEnquiryReminderFailure = (payload) => ({
  type: ADD_ENQUIRY_REMINDER_FAILURE,
  payload,
});
// List Enquiry Reminder
export const fetchEnquiriesReminders = (payload) => ({
  type: FETCH_ENQUIRIES_REMINDERS,
  payload,
});
export const fetchEnquiriesRemindersSuccess = (payload) => ({
  type: FETCH_ENQUIRIES_REMINDERS_SUCCESS,
  payload,
});
export const fetchEnquiriesRemindersFailure = (payload) => ({
  type: FETCH_ENQUIRIES_REMINDERS_FAILURE,
  payload,
});
// EXPORT ENQUIRY
export const exportEnquiry = (payload) => ({
  type: EXPORT_ENQUIRY,
  payload,
});
export const exportEnquirySuccess = (payload) => ({
  type: EXPORT_ENQUIRY_SUCCESS,
  payload,
});
export const exportEnquiryFailure = (payload) => ({
  type: EXPORT_ENQUIRY_FAILURE,
  payload,
});
// IMPORT ENQUIRY
export const importEnquiry = (payload) => ({
  type: IMPORT_ENQUIRY,
  payload,
});
export const importEnquirySuccess = (payload) => ({
  type: IMPORT_ENQUIRY_SUCCESS,
  payload,
});
export const importEnquiryFailure = (payload) => ({
  type: IMPORT_ENQUIRY_FAILURE,
  payload,
});
